import { type } from 'arktype'

import type { InsuranceProduct, InsuranceProductVersion } from '../../model/model.ts'

import type { FrRcpaxePolicyItem, FrRcpaxePolicyItemsState } from './fr-rcpaxe-insurance.ts'
import type { FrRcpaxePricingVersion } from './fr-rcpaxe-pricing-versions.ts'
import type {
  FrRcpaxeActivitiesConfigVersionFormat,
  FrRcpaxeBaseName,
  FrRcpaxeProductVersionFormat,
  FrRcpaxeProductVersionPrefix,
  FrRcpaxeStaticFileIdFormat,
} from './model.ts'
import { frRcpaxePolicyItems_v1_0_0 } from './v1_0_0/policy-items.ts'
import { frRcpaxeStaticFilesIds_v1_0_0 } from './v1_0_0/static-files.ts'

export const frRcpaxeProductVersions = [
  /**
   * Initial version: the fr-rcpw offer, carried by Axeria.
   */
  'product-fr-rcp-axeria-1.0.0-2026-10-04',
] as const satisfies FrRcpaxeProductVersionFormat[]

export const frRcpaxeProductVersionSchema = type('===', ...frRcpaxeProductVersions)

export type FrRcpaxeProductVersion = (typeof frRcpaxeProductVersions)[number]

type FrRcpaxeInsuranceProductVersion = InsuranceProductVersion<
  FrRcpaxeProductVersionPrefix,
  FrRcpaxeBaseName,
  FrRcpaxeProductVersion,
  FrRcpaxePolicyItem,
  FrRcpaxeStaticFileIdFormat,
  FrRcpaxePricingVersion,
  FrRcpaxeActivitiesConfigVersionFormat,
  FrRcpaxePolicyItemsState
>

type FrRcpaxeInsuranceProduct = InsuranceProduct<
  FrRcpaxeProductVersionPrefix,
  FrRcpaxeBaseName,
  FrRcpaxeProductVersion,
  FrRcpaxePolicyItem,
  FrRcpaxeStaticFileIdFormat,
  FrRcpaxePricingVersion,
  FrRcpaxeActivitiesConfigVersionFormat,
  FrRcpaxePolicyItemsState
>

const frRcpaxeProduct_v1_0_0 = {
  version: 'product-fr-rcp-axeria-1.0.0-2026-10-04',
  description: 'Initial version of FR-RCPAXE product',
  policyItems: frRcpaxePolicyItems_v1_0_0,
  staticFilesId: [...frRcpaxeStaticFilesIds_v1_0_0],
  pricingVersion: ['pricing-fr-rcp-axeria-1.0.0-2026-10-04', 'pricing-fr-rcp-axeria-1.0.1-2027-01-01'],
  activitiesConfigVersion: 'activities-config-fr-rcp-axeria-1.0.0-2026-10-04',
} as const satisfies FrRcpaxeInsuranceProductVersion

export const frRcpaxeProduct = {
  id: 'fr-rcpaxe',
  versions: {
    'product-fr-rcp-axeria-1.0.0-2026-10-04': frRcpaxeProduct_v1_0_0,
  },
} as const satisfies FrRcpaxeInsuranceProduct
export type FrRcpaxeProduct = typeof frRcpaxeProduct
